module.exports = __webpack_public_path__ + "static/media/rizwan.6dab6124.jpg";